import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { getStore } from '../actions/storeActions';
import useAxios from '../axios/useAxios';

export const ProtectedRoute = ({ children }) => {
  const axiosInstance = useAxios();
  const dispatch = useDispatch();
  const storeState = useSelector((state) => state.store);
  const cartState = useSelector((state) => state.cart);
  const [isChecking, setIsChecking] = useState(true);
  const [shouldRedirect, setShouldRedirect] = useState(false);

  useEffect(() => {
    if (!cartState) {
      setShouldRedirect(true);
      setIsChecking(false);
      return;
    }

    const { cartItems } = cartState;
    if (cartItems === undefined || cartItems === null) {
      setShouldRedirect(true);
      setIsChecking(false);
      return;
    }

    if (!cartItems._id) {
      setShouldRedirect(true);
      setIsChecking(false);
      return;
    }

    if (!storeState) {
      setShouldRedirect(true);
      setIsChecking(false);
      return;
    }

    setIsChecking(false);
  }, [cartState, storeState]);

  useEffect(() => {
    if (!shouldRedirect && !isChecking && cartState?.cartItems?.storeId) {
      const storeNeedsLoading = !storeState || !storeState.id || storeState.id !== cartState.cartItems.storeId;

      if (storeNeedsLoading) {
        dispatch(getStore(cartState.cartItems.storeId, axiosInstance));
      }
    }
  }, [isChecking, shouldRedirect]);

  if (isChecking) {
    return (
      <div className="flex items-center justify-center h-screen">
        <p>Chargement...</p>
      </div>
    );
  }

  if (shouldRedirect) {
    return <Navigate to="/" replace />;
  }

  return children;
};
